import { LEARN_MORE_LINK, KPI_DEFINITIONS, LEARN_MORE_TEXT } from 'src/utils/kpiDefinitions';


export const kpiTooltipConfig = {
  revenue: {
    title: 'Revenue',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.Revenue_market_aggregated.definitionLines,
    ctaUrl: KPI_DEFINITIONS.Revenue_market_aggregated.ctaUrl,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.Revenue_market_aggregated.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  occupancy: {
    title: 'Occupancy Rate',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.Occupancy_market_aggregated.definitionLines,
    ctaUrl: KPI_DEFINITIONS.Occupancy_market_aggregated.ctaUrl,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.Occupancy_market_aggregated.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  daily: {
    title: 'Nightly Rate',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.ADR_market_aggregated.definitionLines,
    ctaUrl: LEARN_MORE_LINK.adr,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.ADR_market_aggregated.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  listing: {
    title: 'Active Listings',
    timePeriod: 'ltm',
    description: [
      'This shows the number of listings that were active for 90+ days in the last 12 months.',
      'It may differ from the monthly supply graph, which shows listings that were active in a specific month.',
    ],
    ctaUrl: LEARN_MORE_LINK.activeListings,
    urlTexts: {
      ctaText: LEARN_MORE_TEXT,
      showLinkIcon: true,
    },
  },
  seasonality: {
    title: 'Seasonality',
    timePeriod: 'ltm',
    description: [
      'This shows how revenue changes month to month compared to the yearly average. Calculated as the revenue difference between the highest and lowest months.',
    ],
    calcRef: [
      'High seasonality: Revenue changes significantly throughout the year (> 75%).',
      'Mid seasonality: Revenue shows moderate variation during the year (51% to 75%).',
      'Low seasonality: Revenue remains relatively consistent throughout the year (≤ 50%).',
    ],
    ctaUrl: LEARN_MORE_LINK.seasonality,
    urlTexts: {
      ctaText: LEARN_MORE_TEXT,
      showLinkIcon: true,
    },
  },
  trend: {
    title: 'Trend',
    timePeriod: 'ltm',
    description: ['This shows year-over-year changes in revenue.'],
    ctaUrl: LEARN_MORE_LINK.trend,
    urlTexts: {
      ctaText: LEARN_MORE_TEXT,
      showLinkIcon: true,
    },
  },
  revenueIndividualListing: {
    title: 'Revenue',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.Revenue_listing_LTM.definitionLines,
    ctaUrl: KPI_DEFINITIONS.Revenue_listing_LTM.ctaUrl,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.Revenue_listing_LTM.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  occupancyIndividualListing: {
    title: 'Occupancy Rate',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.Occupancy_listing_LTM.definitionLines,
    ctaUrl: KPI_DEFINITIONS.Occupancy_listing_LTM.ctaUrl,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.Occupancy_listing_LTM.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  dailyIndividualListing: {
    title: 'Nightly Rate',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.ADR_market_aggregated.definitionLines,
    ctaUrl: LEARN_MORE_LINK.adr,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.ADR_market_aggregated.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  revenuePotentialIndividualListing: {
    title: 'Revenue Potential',
    timePeriod: 'ltm',
    description: KPI_DEFINITIONS.Revenue_potential_listing_LTM.definitionLines,
    ctaUrl: KPI_DEFINITIONS.Revenue_potential_listing_LTM.ctaUrl,
    urlTexts: {
      ctaText: KPI_DEFINITIONS.Revenue_potential_listing_LTM.learnMoreLinkText,
      showLinkIcon: true,
    },
  },
  daysAvailableIndividualListing: {
    title: 'Days Available',
    timePeriod: 'ltm',
    description: [
      'Total number of days this Airbnb listing was available for booking over the past 12 months',
    ],
  },
};
